import React, { useEffect, useState } from "react";

import { getLayoutState } from "../../../slices/layouts/reducer";
import { useAppSelector, useAppDispatch } from "../../../slices/hook";

import { BrandingData } from "admin-portal/settings/branding";
import NoneAuthLayoutSwitch from "../none-auth-layout-switch";
import { getAuthState } from "slices/auth/login/reducer";
import { RoutePath } from "routes/route-path";
import { useNavigate } from "react-router-dom";
import LoadingComponent from "common/components/loader";
import { AppDispatch } from "slices/store";
import { userSwitchTenantThunk } from "slices/thunk";
import { TenantType } from "models/enums";

const AdminSwitchTenantPage = () => {
  document.title = "Switch " + BrandingData.titleSuffix;
  const navigate = useNavigate();
  const dispatch: AppDispatch = useAppDispatch();
  const { loading, loggedInuser, error, sessionToken } = useAppSelector(getAuthState);

  useEffect(() => {
    if (loggedInuser?.activeTenantId) {
      navigate(RoutePath.Admin_Dashborad_page);
    }
  }, [loggedInuser]);

  const switchTenant = (tenant: string) => {
    dispatch(userSwitchTenantThunk(tenant));
  };

  React.useEffect(() => {
    const bodyElement = document.body;

    bodyElement.classList.add(
      "flex",
      "items-center",
      "justify-center",
      "min-h-screen",
      "py-16",
      "lg:py-10",
      "bg-slate-50",
      "dark:bg-zink-800",
      "dark:text-zink-100",
      "font-public"
    );

    return () => {
      bodyElement.classList.remove(
        "flex",
        "items-center",
        "justify-center",
        "min-h-screen",
        "py-16",
        "lg:py-10",
        "bg-slate-50",
        "dark:bg-zink-800",
        "dark:text-zink-100",
        "font-public"
      );
    };
  }, []);

  const [selectedTenantId, setSelectedTenantId] = useState(null);

  const handleRadioChange = (event: any) => {
    setSelectedTenantId(event.target.value);
  };

  const handleContinueClick = () => {
    if (selectedTenantId) {
      switchTenant(selectedTenantId);
    } else {
      //alert("Please select a tenant.");
    }
  };

  return (
    <React.Fragment>
      <NoneAuthLayoutSwitch>
        <div className="flex items-center justify-center">
          <div className="flex flex-col gap-2 p-6 mt-8 ">
            <div className="mt-8 text-center">
              <h4 className="mb-2 text-custom-500 dark:text-custom-500">Select {BrandingData.bussinessDomain}</h4>
              <p className="mb-8 text-slate-500 dark:text-zink-200"></p>
            </div>

            {(loggedInuser?.tenants ?? []).map((tn) => (
              <div key={tn.id} className="flex items-center gap-2">
                <input
                  id={`radio-${tn.id}`}
                  name="tenant" // Ensure all radio buttons share the same name
                  className="size-4 cursor-pointer bg-white border border-slate-200 dark:bg-zink-700 dark:border-zink-500 rounded-full appearance-none arrow-none relative after:absolute after:content-['\eb7c'] after:text-[8px] after:top-[3px] after:left-[3px] after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-green-500 checked:border-green-500 dark:after:text-green-500 dark:checked:border-green-800"
                  type="radio"
                  value={tn.id}
                  checked={selectedTenantId === tn.id}
                  onChange={handleRadioChange}
                />
                <label htmlFor={`radio-${tn.id}`} className="align-middle">
                  {tn.companyName}
                </label>
              </div>
            ))}

            <div className="mt-10">
              <button
                type="button"
                onClick={handleContinueClick}
                className="w-full text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Continue
              </button>
            </div>

            <div className="mt-10">{loading && <LoadingComponent />}</div>
            <div className="mt-10"> {error && <span className="text-red-500">{error}</span>}</div>
          </div>
        </div>
      </NoneAuthLayoutSwitch>
    </React.Fragment>
  );
};

export default AdminSwitchTenantPage;
